import {
    ButtonWidgetBaseData,
    IButtonBaseStyle, IFontData, IPagePrimaryElement, IWidgetVisibility, VisibilityData, WidgetPlaceType
} from "../index";
import { IAnimatedWidget } from "../widget-style-data";

export interface ICalendarEventListWidgetData extends IWidgetVisibility, IPagePrimaryElement {
    readonly type: "CalendarEventListWidget";
    placeType: WidgetPlaceType;
    id?: string | null;
    style: ICalendarEventListWidgetStyle;
    layout: CalendarEventListLayout
}

export enum CalendarEventListLayout {
    Magazine = "Magazine",
}

export interface ICalendarEventListWidgetStyle extends IAnimatedWidget {
    headingFont: IFontData;
    dateFont: IFontData;
    priceFont: IFontData;
    button: IButtonBaseStyle
    backgroundColor: string;
}

export abstract class CalendarEventListWidgetData {

    public static updateWithDefaults(data: ICalendarEventListWidgetData): void {
        data.style = this.defaultData.style;
        data.visibility = this.defaultData.visibility;
    }

    public static get defaultData(): ICalendarEventListWidgetData {
        return {
            type: "CalendarEventListWidget",
            placeType: "Section",
            style: this.defaultStyle,
            visibility: VisibilityData.defaultData(),
            layout: CalendarEventListLayout.Magazine,
            primaryElement: true
        };
    }

    public static get defaultStyle(): ICalendarEventListWidgetStyle {
        return {
            headingFont: {},
            dateFont: {},
            priceFont: {},
            button: ButtonWidgetBaseData.defaultButtonStyle,
            backgroundColor: "#FFFFFF",
            animation: {
                animationSource: "site-design",
                animationData: {
                    name: "none",
                    duration: 1
                }
            }
        };
    }

}
